
// region JS Imports

// region External Modules
import $ from "jquery"
// endregion External Modules

// region Private Modules
//endregion Private modules

// region Public Components
import {
  RoomSelectPicker,
} from "components/js_selectpicker/room_selectpicker"
import {
  InputSelector as BaseInputSelector,
  Selector as BaseSelector,
} from "components/js_selectpicker/base"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


type Selector = BaseSelector & {
  container:    string
  main:         string
  first_option: string
}

type InputSelector = BaseInputSelector & {
  container?:    string
  main?:         string
  first_option?: string
}

const default_selector = {
  scope:        ".cell--serviced-apartments--searches--filter-bar--property-type__wrapper",
  main:         ".cell--serviced-apartments--searches--filter-bar--property-type",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
  container:    ".select2-container",
}


export class PropertyTypeSelector extends RoomSelectPicker {
  protected selector: Selector

  protected $container:    JQuery
  protected $el:           JQuery
  protected $first_option: JQuery

  private readonly default_selector_text?: string

  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, default_selector, selector)

    super(merged_selector)
    this.selector = merged_selector

    this.$el = $(this.selector.main)

    this.$container = this.$scope.find(this.selector.container)
    this.$first_option = this.$scope.find(this.selector.first_option)

    this.default_selector_text = this.$scope.find(this.selector.main).attr("data-default-text")

    this.reset()
  }


  protected extra_select2_options(): Select2.Options {
    return {
      dropdownAutoWidth: true,
      width:             "auto",
      templateSelection: (data: any) => {
        return this.customRenderText(data)
      },
    }
  }

  private customRenderText(data: any): string {
    if (!data.id || data.id === "" || data.id === this.$first_option.val()) {
      return <string>this.default_selector_text
    }
    return data.text
  }

  protected triggerVisualChange(): void {
    this.setTextNormal()
  }

}


const Factory = {
  create(selector?: InputSelector): PropertyTypeSelector {
    return new PropertyTypeSelector(selector)
  },
}

export {
  Factory,
}
